import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Plus } from "lucide-react";

interface SubmissionSuccessProps {
  onSubmitAnother: () => void;
}

export function SubmissionSuccess({ onSubmitAnother }: SubmissionSuccessProps) {
  return (
    <Card>
      <CardHeader className="text-center">
        <div className="flex justify-center mb-4">
          <div className="h-20 w-20 rounded-full bg-green-100 dark:bg-green-900/20 flex items-center justify-center">
            <CheckCircle2 className="h-12 w-12 text-green-600" />
          </div>
        </div>
        <CardTitle className="text-2xl text-green-600">Enviado com Sucesso!</CardTitle>
        <CardDescription className="text-base">
          Seus dados foram recebidos com segurança
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="text-center space-y-2">
          <p className="text-muted-foreground">
            Seu profissional de saúde receberá uma notificação e analisará os dados em breve.
          </p>
          <p className="text-sm text-muted-foreground">
            Você receberá um retorno assim que a análise for concluída.
          </p>
        </div>

        <div className="p-4 bg-muted rounded-lg">
          <h3 className="font-semibold mb-2">O que acontece agora?</h3>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li className="flex items-start gap-2">
              <span className="text-primary font-bold">1.</span>
              <span>Seu profissional revisará os dados enviados</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary font-bold">2.</span>
              <span>Se aprovado, será processado com Inteligência Artificial</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary font-bold">3.</span>
              <span>Os insights serão adicionados ao seu histórico clínico</span>
            </li>
          </ul>
        </div>

        <Button onClick={onSubmitAnother} className="w-full" size="lg">
          <Plus className="h-4 w-4 mr-2" />
          Enviar Mais Dados
        </Button>
      </CardContent>
    </Card>
  );
}
